{
  "archive_task": "Архивировать задачу",
  "archive_task_confirm": "Вы уверены, что хотите архивировать эту задачу?",
  "change_status": "Изменить статус",
  "create_task": "Создать задачу",
  "description_placeholder": "Опишите задачу подробнее...",
  "edit_task": "Редактировать задачу",
  "from_employee": "От {name}",
  "mark_complete": "Отметить выполненной",
  "mark_in_progress": "Взять в работу",
  "mark_todo": "Вернуть в «к выполнению»",
  "more_tasks_for_you": "Ещё задачи для вас",
  "my_tasks": "Мои задачи",
  "notification_settings_tasks_caption": "Когда вам назначают задачи или вносят изменения",
  "notification_settings_tasks_overdue_caption": "Когда ваши задачи становятся просроченными",
  "permissions_create_description": "Возможность создавать задачи для других сотрудников",
  "permissions_create_title": "Создание задач",
  "permissions_manage_all_description": "Просмотр, редактирование и архивирование задач всех сотрудников",
  "permissions_manage_all_title": "Управление всеми задачами",
  "permissions_module_description": "Доступ к модулю задач",
  "permissions_module_title": "Модуль задач",
  "related_employee": "Связанный сотрудник",
  "section_empty_description_archive": "Задачи, которые вы отправите в архив, появятся здесь.",
  "section_empty_description_assignee": "На этого сотрудника ещё не назначены задачи.",
  "section_empty_description_done": "Завершённые задачи появятся здесь.",
  "section_empty_description_related": "Задач, связанных с этим сотрудником, пока нет.",
  "section_empty_description_todo": "Задачи, которые вам назначат, появятся здесь.",
  "section_empty_title_archive": "Нет архивных задач",
  "section_empty_title_done": "Завершённых задач пока нет",
  "section_empty_title_todo": "Задач пока нет",
  "section_empty_title_watching": "Нет задач под наблюдением",
  "section_title_archived": "Архивные",
  "section_title_completed": "Завершённые",
  "section_title_overdue": "Просроченные",
  "overdue_alerts_sent_anyway": "Оповещения о просрочке отправляются всегда",
  "overdue_alerts_sent_regardless": "Уведомления о просрочке будут отправляться независимо от выбранной опции",
  "section_title_todo": "К выполнению",
  "section_title_watching": "Наблюдаю",
  "task": "Задача",
  "task_action_and_assigned_to": "и назначена на {name}",
  "task_action_archived": "Архивирована",
  "task_action_completed": "Завершена",
  "task_action_created": "Создана",
  "task_action_started": "Взята в работу",
  "task_action_stopped": "Снята с работы",
  "task_action_uncompleted": "Возвращена в «К выполнению»",
  "task_action_updated": "Обновлена",
  "tasks_related_employee": "{tasks}, где упоминается {employee}",
  "task_status_completed": "Завершена",
  "task_status_in_progress": "В работе",
  "task_status_todo": "К выполнению",
  "tasks": "Задачи",
  "tasks_as_assignee": "Задачи",
  "tasks_as_related": "Связанные задачи",
  "tasks_feature_description": "Назначайте и отслеживайте задачи для сотрудников.",
  "tasks_overdue": "Просроченные задачи",
  "things_to_do": "Мои задачи",
  "title_placeholder": "Введите название задачи",
  "title_todo_count_prefix": "У вас",
  "title_todo_count_zero": "Все задачи выполнены!",
  "view_task": "Посмотреть задачу",
  "watcher": "Наблюдатель",
  "watchers": "Наблюдатели",
  "task_workflow_caption": "Автоматизация сценариев",
  "task_action_created_by_workflow": "Создана сценарием",
  "from_workflow": "Из сценария {title}"
}
